import gql from "graphql-tag";

export const USERS_QUERY = gql`
  query Users(
    $officeId: SmartID
    $search: String
    $first: Int
    $offset: Int
    $isPending: Boolean
  ) {
    users(
      officeId: $officeId
      search: $search
      first: $first
      offset: $offset
      isPending: $isPending
    ) {
      id
      firstName
      lastName
      email
      role
      isActive
      dateJoined
      lastLogin
      inviter {
        id
        firstName
        lastName
      }
      invitationExpiresInSeconds
      invitationRevokedBy {
        id
        firstName
        lastName
      }
      clientUserServiceAlertRules {
        edges {
          node {
            id
            action
            type
            maxPerToLowerBid
            serviceId
          }
        }
      }
      office {
        id
      }
      additionalOfficeIds
    }
    usersCount(officeId: $officeId, search: $search, isPending: $isPending)
    pendingCount: usersCount(officeId: $officeId, isPending: true)
  }
`;

export const PENDING_USERS_QUERY = gql`
  query PendingUsers(
    $officeId: SmartID
    $search: String
    $first: Int
    $offset: Int
  ) {
    pendingUsers: users(
      officeId: $officeId
      search: $search
      first: $first
      offset: $offset
      isPending: true
    ) {
      id
      firstName
      lastName
      email
      role
      isActive
      dateJoined
      lastLogin
      inviter {
        id
        firstName
        lastName
      }
      invitationExpiresInSeconds
      invitationRevokedBy {
        id
        firstName
        lastName
      }
      clientUserServiceAlertRules {
        edges {
          node {
            id
            action
            type
            maxPerToLowerBid
            serviceId
          }
        }
      }
      office {
        id
      }
      additionalOfficeIds
    }
    pendingUsersCount: usersCount(
      officeId: $officeId
      search: $search
      isPending: true
    )
  }
`;
